export default "__VITE_ASSET__AcRSzQHb__"